import { message } from 'antd'
import Context from 'containers/UMS/Users/Context'
import { useContext } from 'react'
import { useMutation } from 'react-query'
import axiosRequest from 'utils/axiosRequest'
// helpers
import get from 'lodash/get'
import useLogAction from 'hooks/useLogAction'

const manageUser = async ({ user, action }) => {
  const { data } = await axiosRequest({
    url: '/admin/user-management',
    method: 'POST',
    data: {
      uuid: user,
      action
    }
  })

  return data
}

const useManageUSer = setPopOpen => {
  const {
    queryHandler: { data },
    states: { page },
    actions: { setDirtyBit, setPage }
  } = useContext(Context)

  const paginationInfo = get(data, 'paginationInfo', {
    currentPage: 1,
    recordsPerPage: 7,
    totalPages: 1,
    totalRecords: 1
  })
  const { logAction } = useLogAction()
  const { isLoading, isError, mutate } = useMutation({
    mutationKey: 'manage_user',
    mutationFn: manageUser,
    onSuccess: () => {
      const { totalRecords, currentPage, totalPages } = paginationInfo
      setPopOpen(false)

      if (
        currentPage > Math.ceil((totalRecords - 1) / 9) &&
        currentPage !== 1
      ) {
        setPage(page - 1)
      } else setDirtyBit(true)

      message.success({
        type: 'success',
        content: 'Acción realizada con exito'
      })
    },
    onError: () => {
      message.error({
        type: 'error',
        content: 'Ha ocurrido un error'
      })
    }
  })

  const onClick = (user, action) => {
    mutate({ user, action }, {
      onSuccess: () => {
        const dataU = get(data, 'data', [])
        const userInfo = dataU.find(({ identity_uuid }) => user === identity_uuid)

        logAction({
          event: "AIRFIND_USER", action: "UPDATE", metadata: {
            actionType: `${action}AirfindUser`,
            userInfo: {
              uuid: user,
              firstname: userInfo?.identity_first_name,
              lastname: userInfo?.identity_last_name,
              email: userInfo?.identity_email,
              phone: userInfo?.identity_phone,
              points: userInfo?.identity_point_count
            }
          }
        })
      }
    })
  }

  return {
    isLoading,
    isError,
    onClick
  }
}

export default useManageUSer
